<script lang="ts" setup>
import App from '@/components/App.vue';
</script>

<template>
  <Suspense>
    <App />
  </Suspense>
</template>
